export default class PdfViewerToolbarButtonGroupComponent {
    constructor(hostElement) {
        this.hostElement = hostElement;
        this.prefix = 'sp-pdf-viewer';
        this.render = () => {
            this.element = document.createElement('div');
            this.element.classList.add(`${this.prefix}-toolbar-group`);
            this.hostElement.appendChild(this.element);
        };
        this.destroy = () => {
            this.hostElement.removeChild(this.element);
            this.element = null;
        };
    }
}
//# sourceMappingURL=pdf-viewer-toolbar-button-group.component.js.map